import queryString from 'qs';
import moment from 'moment';

export const getTotalRequestReschedulePayload = (query) => {
  const queries = {
    date: moment(query).format('YYYY-MM-DD'),
  };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getTotalRequestReschedulePayload;
